export const CNCT = {
  COLORS: ["#3E64D5", "#9AAEE9", "#CDD7F4", "#ABA9BC"],
  NOT_DATA_COLOR: "#F1F1F4",
  CHART: {
    WIDTH: 160,
    HEIGHT: 160,
    INNER_RADIUS: 60,
    OUTER_RADIUS: 80,
    START_ANGLE: 90,
    END_ANGLE: -270,
    AD_CLICK: {
      DATA_KEY: "count",
    },
    STAY_TIME: {
      DATA_KEY: "time",
    },
  },
} as const;

export const API_ENDPOINT_CONNECT = import.meta.env.VITE_API_ENDPOINT_CONNECT;
